<template>
  <el-scrollbar
    class="nav-monitor__menu"
    :native="true"
    :wrap-style="scrollWrapStyle"
    wrap-class="el-scrollbar-custom__wrap"
  >
    <el-menu :default-active="active" @open="openHandler" @select="selectHandler">
      <template v-for="(item, index) in list">
        <MenuItem :item="item" :key="`itme-${index}`" />
      </template>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { isMobile } from '@/utils/is';
import MenuItem from './menu-item.vue';

export default {
  components: { MenuItem },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    defaultActive: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      active: this.defaultActive || ''
    };
  },
  computed: {
    scrollWrapStyle() {
      const val = isMobile() ? 'unset' : '-17px';
      return {
        marignRight: val,
        marignBottom: val
      };
    }
  },
  methods: {
    selectHandler(id) {
      this.$emit('select', { id, nodeType: 2 });
    },
    openHandler(id) {
      this.$emit('open', { id, nodeType: 1 });
    }
  }
};
</script>

<style lang="scss">
.nav-monitor__menu {
  max-height: calc(100% - 40px);
  height: calc(100% - 40px);
  .el-scrollbar-custom__wrap {
    overflow-x: hidden;
  }
}
</style>
